module.exports = __webpack_public_path__ + "static/media/reservation_type_dining.13e146da.png";